import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import EN from 'components/Header/locales/Header_en_US.js';
import FR from 'components/Header/locales/Header_fr_CA.js';
import LanguageLocale from 'utils/LanguageLocale';
import addressUtils from 'utils/Address';
const { getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(EN, FR);

function PreferredStoreAndZipCode({ storeNameAndZipCode = '', ...restProps }) {
    const [storeLocation, setStoreLocation] = React.useState(getText('chooseYourStoreAndLocation'));

    React.useEffect(() => {
        const country = LanguageLocale?.getCurrentCountry()?.toUpperCase();
        const isUSZipCode = addressUtils.US_ZIP_CODE_FORMAT.test(storeNameAndZipCode);
        const isCanadaWithUSZip = country === 'CA' && isUSZipCode;

        setStoreLocation(isCanadaWithUSZip ? getText('chooseYourStoreAndLocation') : storeNameAndZipCode);
    }, [storeNameAndZipCode]);

    return (
        <Text
            fontSize='sm'
            display='block'
            paddingBottom={1}
            marginBottom={-1}
            {...restProps}
        >
            {storeLocation}
        </Text>
    );
}

PreferredStoreAndZipCode.propTypes = {
    storeNameAndZipCode: PropTypes.string
};

export default wrapFunctionalComponent(PreferredStoreAndZipCode, 'PreferredStoreAndZipCode');
